import type { HelpFile } from '../../types/help'
import { ExecutionDetailTestIds } from '../../../testids/ExecutionDetailTestIds'

export const executionDetailHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [ExecutionDetailTestIds.executionDetailTitle]:
      'Details einer einzelnen Job-Ausführung — Status, Zeitplanung, Aufgabenbaum und Fehlerinformationen.',
    [ExecutionDetailTestIds.cardExecutionInfo]:
      'Zusammenfassung der Ausführung — Status, Start- und Endzeit, Dauer sowie auslösender Nutzer oder Zeitplan.',
    [ExecutionDetailTestIds.btnCancelExecution]:
      'Abbruch dieser laufenden Ausführung anfordern — der Job stoppt am nächsten sicheren Prüfpunkt.',
    [ExecutionDetailTestIds.cardTitleExecutionError]:
      'Fehlermeldung und Stack-Trace, die beim Scheitern dieser Ausführung erfasst wurden.',
    [ExecutionDetailTestIds.linkJobDetail]:
      'Übergeordneten Job öffnen, um Definition und andere Ausführungen einzusehen.',
    [ExecutionDetailTestIds.sectionExecutionStatistics]:
      'Vom Job gemeldete Zähler — verarbeitete, erfolgreiche und fehlgeschlagene Einträge.',
    [ExecutionDetailTestIds.sectionTaskExecutions]:
      'Vom Job gestartete Einzelaufgaben mit Status und Dauer.',
    [ExecutionDetailTestIds.badgeSseConnection]:
      'Verbindungsstatus der Live-Aktualisierung für diese Ausführung — verbindet, verbunden oder getrennt.',
    [ExecutionDetailTestIds.executionErrorMessage]:
      'Die Fehlermeldung beim Scheitern der Ausführung — Grundlage für die Diagnose der Ursache.',
  },
}
